/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCampaignsCampaignType =
    (typeof GetApiCampaignsCampaignType)[keyof typeof GetApiCampaignsCampaignType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCampaignsCampaignType = {
    EMAIL: 'EMAIL',
    SMS: 'SMS',
    TRIGGER: 'TRIGGER',
} as const;
